export const baseGuideLevelValidators = {};
